import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { PoliticaTratamientoDatosPersonalesComponent } from '../../util/modal-politica/politica-tratamiento-datos-personales/politica-tratamiento-datos-personales.component';
import { EntidadDto } from '../../../dto/expediente/entidad.dto';
import { TipoProcesoDto } from '../../../dto/expediente/tipo-proceso.dto';
import { EntidadSegundaInstanciaDto } from '../../../dto/expediente/entidad-segunda-instancia.dto';
import { TableColumn } from '../../../dto/util/table-column';
import { TableAction } from '../../../dto/util/table-action';
import { UserDataDto } from '../../../dto/auth/user-data.dto';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../services/util.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from '../../../services/util/spinner.service';
import { ListasService } from '../../../services/listas.service';
import { Constants } from '../../../constants/constants';
import { SegundaInstanciaService } from '../../../services/segunda-instancia.service';
import { ExpedienteSegundaInstanciaFiltroDto } from '../../../dto/expediente/expediente-segunda-instancia.filtro.dto';
import { ExpedienteSegundaInstanciaDto } from '../../../dto/expediente/expediente-segunda-instancia.dto';
import { ListaValorDto } from '../../../dto/expediente/lista-valor.dto';
import { ListaValorConstants } from '../../../constants/lista-valor.constants';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-expedientes-segunda-instancia',
  templateUrl: './expedientes-segunda-instancia.component.html',
  styleUrl: './expedientes-segunda-instancia.component.scss'
})
export class ExpedientesSegundaInstanciaComponent
implements OnInit, AfterViewInit{

  @ViewChild(PoliticaTratamientoDatosPersonalesComponent)
  politicaTratamientoDatosPersonalesComponent!: PoliticaTratamientoDatosPersonalesComponent;

  expedientesSegundaInstancia: ExpedienteSegundaInstanciaDto[] = [];
  entidades: EntidadDto[] = [];
  entidadesSegundaInstancia: EntidadSegundaInstanciaDto[] = [];
  tiposProceso: TipoProcesoDto[] = [];
  columns: TableColumn[] = [];
  acciones: TableAction[] = [];
  estadosSegundaInstancia: ListaValorDto[] = [];
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  userData: UserDataDto = {};
  filtros: FiltroDto<ExpedienteSegundaInstanciaFiltroDto> = {
    pagina: 1,
    tamanoPagina: this.tamanoPagina,
    ordenarAsc: false,
    ordenarPor: 'Radicado',
    filtros: {},
  };
  esBuscar?: boolean;
  // Multilenguaje
  tableText: any = {};
  guiaText: any = {};
  guiaGestionExpedienteText: any = {};
  selectedItems: any = [];
  expedientesEnviados: number = 0;
  expedientesEnPreparacion: number = 0;
  expedientesAcuse: number = 0;
  expedientesEFJE: number = 0;
  expedientesRadicadoSegundaInstancia: number = 0;
  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;

  constructor(
    private readonly utilService: UtilService,
    private readonly router: Router,
    private readonly spinnerService: SpinnerService,
    private readonly listasService: ListasService,
    private readonly translate: TranslateService,
    private readonly segundaInstanciaService: SegundaInstanciaService
  ){
    // Multilenguaje
    combineLatest({
      guia: this.translate.stream('guias-interactivas'),
      tablas: this.translate.stream('gestion-expedientes-segunda-instancia-tabla'),
      guiaExpediente: this.translate.stream('guia-gestion-expediente'),
    }).subscribe(({ guia, tablas, guiaExpediente }) => {
      // Asignar traducciones a variables
      this.guiaText = guia;
      this.tableText = tablas;
      this.guiaGestionExpedienteText = guiaExpediente;
      // Construir formularios después de cargar traducciones
        this.initColumns();
      });
  }

  ngOnInit(): void {
    // Se toma la información del usuario que inicia sesión
    this.userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.listarExpedientesSegundaInstancia();
    this.listarEntidades();
    this.listarEntidadesSegundaInstancia();
    this.consultarEstadoExpedientesSegundaInstancia();
    this.consultarListaEstadoExpedientesSegundaInstancia();
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaGestionExpedienteText['titulo'],
      descripcionPantalla: this.guiaGestionExpedienteText['descripcion'],
      pasos: [
        {
          element: '#tour',
          popover: {
            title: this.guiaGestionExpedienteText['tour-titulo'],
            description: this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#filtro',
          popover: {
            title: this.guiaGestionExpedienteText['filtro-titulo'],
            description: this.guiaGestionExpedienteText['filtro-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#crearSolicitud',
          popover: {
            title: this.guiaGestionExpedienteText['crear-solicitud-titulo'],
            description: this.guiaGestionExpedienteText['crear-solicitud-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historico',
          popover: {
            title: this.guiaGestionExpedienteText['historico-titulo'],
            description: this.guiaGestionExpedienteText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#Radicado',
          popover: {
            title: this.guiaGestionExpedienteText['proceso-titulo'],
            description: this.guiaGestionExpedienteText['proceso-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#entidad',
          popover: {
            title: this.guiaGestionExpedienteText['entidad-titulo'],
            description: this.guiaGestionExpedienteText['entidad-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#tipoProceso',
          popover: {
            title: this.guiaGestionExpedienteText['tipo-proceso-titulo'],
            description: this.guiaGestionExpedienteText['tipo-proceso-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#Fecha_Creacion',
          popover: {
            title: this.guiaGestionExpedienteText['fecha-creacion-titulo'],
            description: this.guiaGestionExpedienteText['fecha-creacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#Fecha_Ultima_Modificacion',
          popover: {
            title: this.guiaGestionExpedienteText['fecha-actualizacion-titulo'],
            description: this.guiaGestionExpedienteText['fecha-actualizacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#estado',
          popover: {
            title: this.guiaGestionExpedienteText['estado-titulo'],
            description: this.guiaGestionExpedienteText['estado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    };
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (this.userData.primerInicioSesion) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
    this.utilService.show();
    this.initColumns();
  }

  ngAfterViewInit(): void {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    const rol = JSON.parse(sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    const tipoUsuario = rol.Nombre;
    if (
      (tipoUsuario == 'Ciudadano' || tipoUsuario == 'Abogado') &&
      infoInicioSesion.aceptoDatos == false
    ) {
      this.politicaTratamientoDatosPersonalesComponent.abrirModal();
    }
  }

  initColumns() {
    this.columns = [
      {
        field: 'Expediente.Radicado',
        title: this.tableText['numero-proceso'],
        type: 'number',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'numeroProceso',
        width: '10rem',
        accion: (item: ExpedienteSegundaInstanciaDto) => {
          if (item.Expediente.Estado_Expediente?.Proceso_Finalizado) {
            this.utilService.hide();
          }
          switch (item?.Expediente.Tipo_Proceso?.Entidad_Id) {
            case 1:
              this.router.navigate(['/expediente/supersociedades',item?.Expediente?.Id]);
              break;
            case 2:
              this.router.navigate(['/expediente/sic/', item?.Expediente?.Id]);
              break;
            case 3:
              this.router.navigate(['/expediente/supersalud',item?.Expediente?.Id]);
              break;
            case 4:
              this.router.navigate(['/expediente/superfinanciera', item?.Expediente?.Id]);
              break;
            case 5:
              this.router.navigate(['/expediente/dnda', item?.Expediente?.Id]);
              break;
            case 6:
              this.router.navigate(['/expediente/dimar', item?.Expediente?.Id]);
              break;
            case 7:
              this.router.navigate(['/expediente/ica', item?.Expediente?.Id]);
              break;
            case 8:
              this.router.navigate(['/expediente/ssm', item?.Expediente?.Id]);
              break;
            default:
              break;
          }
        },
      },
      {
        id: 'estado',
        field: 'Lista_Valor.Valor',
        title: this.tableText['estado'],
        type: 'select',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'estadoProceso',
        elements: this.estadosSegundaInstancia,
        option: 'Valor',
        value: 'Id',
        width: '15rem',
      },
      {
        field: 'Fecha_Envio',
        title: this.tableText['fecha-envio-segunda-instancia'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fechaEnvioSegundaInstancia',
        pipe: 'dd/MM/yyyy',
        width: '15rem',
      },
      {
        field: 'Fecha_Acuse',
        title: this.tableText['fecha-acuse'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fechaAcuse',
        pipe: 'dd/MM/yyyy',
        width: '15rem',
      },
      {
        id: 'radicadoSegundaInstancia',
        field: 'Numero_Proceso_Segunda_Instancia',
        title: this.tableText['radicado-segunda-instancia'],
        type: 'number',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'numeroProcesoSegundaInstancia',
        width: '12rem',
      },
      {
        id: 'entidad-segunda-instancia',
        field: 'Entidad_Segunda_Instancia.Entidad',
        title: this.tableText['entidad-segunda-instancia'],
        type: 'select',
        filterable: true,
        sortable: true,
        elements: this.entidadesSegundaInstancia,
        fieldFilterElement: 'entidadSegundaInstancia',
        option: 'Entidad',
        value: 'Id',
        width: '15rem',
      },
      {
        id: 'correo-solicitante',
        field: 'Usuario.Correo_electronico',
        title: this.tableText['correo-solicitante'],
        fieldFilterElement: 'correoSolicitante',
        type: 'text',
        filterable: true,
        sortable: true,
        width: '25rem',
      },
    ];
  }

  buscar(event: FiltroDto<object>) {
    this.esBuscar = true;
    this.filtros.ordenarPor =
      event.ordenarPor == '' ? 'Radicado' : event.ordenarPor;
    const filtrosLimpios = event.filtros as ExpedienteSegundaInstanciaFiltroDto;
    for (const key of Object.keys(filtrosLimpios) as Array<keyof ExpedienteSegundaInstanciaFiltroDto>) {
      if (filtrosLimpios[key] == "undefined" || filtrosLimpios[key] == undefined) {
        delete filtrosLimpios[key];
      }
    }
    this.filtros.filtros = filtrosLimpios;

    if (this.filtros.filtros.numeroProceso) {
      this.filtros.filtros.numeroProceso = this.filtros.filtros.numeroProceso;
    }
    if (this.filtros.filtros.correoSolicitante) {
      this.filtros.filtros.correoSolicitante = this.filtros.filtros.correoSolicitante;
    }
    if (this.filtros.filtros.estadoProceso) {
      this.filtros.filtros.estadoProceso = this.filtros.filtros.estadoProceso;
    }
    if (this.filtros.filtros.fechaAcuse) {
      this.filtros.filtros.fechaAcuse = this.filtros.filtros.fechaAcuse;
    }
    if (this.filtros.filtros.fechaSegundaInstancia) {
      this.filtros.filtros.fechaSegundaInstancia = this.filtros.filtros.fechaSegundaInstancia;
    }
    if (this.filtros.filtros.entidadSegundaInstancia) {
      this.filtros.filtros.entidadSegundaInstancia = this.filtros.filtros.entidadSegundaInstancia;
    }
    if (this.filtros.filtros.numeroProcesoSegundaInstancia) {
      this.filtros.filtros.numeroProcesoSegundaInstancia = this.filtros.filtros.numeroProcesoSegundaInstancia;
    }
    this.filtros.ordenarAsc = event.ordenarAsc;
    this.filtros.pagina = +(event.selectedPage ?? 1);
    this.filtros.tamanoPagina = +event.tamanoPagina;
    this.listarExpedientesSegundaInstancia();
    this.consultarEstadoExpedientesSegundaInstancia();
  }

  listarExpedientesSegundaInstancia() {
    this.filtros.filtros.entidad = this.userData.tipoUsuario?.Id_Entidad;
    this.segundaInstanciaService.expedientesSegundaInstancia(this.filtros).subscribe(data => {
      this.expedientesSegundaInstancia = data.registros;
      this.totalPaginas = data.totalPaginas;
      this.paginaActual = data.numeroPagina;
    });
    if (this.esBuscar) {
      this.spinnerService.hideSpinner();
    }
  }

  listarEntidades() {
    this.listasService.getEntidades().subscribe(data => {
      this.entidades = data.filter(item=> item.Id == this.userData.tipoUsuario?.Id_Entidad);
      this.initColumns();
    });
  }

  listarEntidadesSegundaInstancia(){
    this.segundaInstanciaService.getEntidadesSegundaInstancia().subscribe(
      data => {
        this.entidadesSegundaInstancia = data
        this.initColumns()
      })
  }

  consultarEstadoExpedientesSegundaInstancia(){
    this.segundaInstanciaService.estadoExpedientesSegundaInstancia(this.filtros.filtros).subscribe(
      data => {
        this.expedientesEnviados = data.enviados
        this.expedientesEnPreparacion = data.preparacion
        this.expedientesAcuse = data.acuse
        this.expedientesEFJE = data.efje
        this.expedientesRadicadoSegundaInstancia = data.segundaInstancia
      }
    )
  }

  async consultarListaEstadoExpedientesSegundaInstancia(){
    this.listasService.listaValor(ListaValorConstants.EstadosSegundaInstancia).subscribe(
      data => {
       this.estadosSegundaInstancia = data
       this.initColumns()
      }
    )
  }

}
